import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../Services/API/Requests";

export const fetchTreeThunk = createAsyncThunk('fetchTree', async (id) => {
    const advancedFilter = [
        {
            "field": "application",
            "operand": "equal",
            "value": id
        }
    ]
    const schemes = await request({
        url: "/list/getData",
        data: {
            id: "schemaDefaultList",
            advancedFilter
        }
    })
    const screens = await request({
        url: "/list/getData",
        data: {
            id: "screenDefaultList",
            advancedFilter
        }
    })
    const lists = await request({
        url: "/list/getData",
        data: {
            id: "listDefaultList",
            advancedFilter
        }
    })
    const menu = await request({
        url: "/list/getData",
        data: {
            id: "menuDefaultList",
            advancedFilter
        }
    })
    return [
        {
            id: 'entity', name: "Entity", children: schemes.content.map(item => {
                return {...item, properties: [{}]}
            })
        },
        {id: 'screen', name: "Screen", children: screens.content},
        {id: 'menu', name: "Menu", children: menu.content},
        {id: 'list', name: "List", children: lists.content}
    ]
})